import { useTranslation } from 'react-i18next';
import * as React from 'react';
import clsx from 'clsx';

import config from 'config';
import { ProductShape } from 'lib/util/productShape';

import { ProductServiceListItem } from './ProductServiceListItem';
import baseStyles from '../base.module.css';
import styles from './ProductDetailsView.module.css';
import { ContentSection } from './ContentSection/ContentSection';

type Props = {
  product: ProductShape;
};

export const ProductServicesView = ({ product }: Props) => {
  const { t } = useTranslation();

  const [transportationSectionOpen, setTransportationSectionOpen] = React.useState<boolean>(true);
  const [addOnsSectionOpen, setAddOnsSectionOpen] = React.useState<boolean>(true);

  const hasAddOns = product.addOns.length !== 0;
  const hasTransportations = product.transportations.length !== 0;
  const [showAll, setShowAll] = React.useState(false);
  const threshold = 3;

  if (!hasAddOns && !hasTransportations) {
    return null;
  }

  return (
    <ContentSection
      title={t('Add-ons / Transportation')}
      englishTitle="Option"
      className={styles['option']}
    >
      <div className={styles['option__list']}>
        {hasTransportations && (
          <div className={styles['option__list__item']}>
            <div
              className={clsx(
                styles['option__list__item__ttl'],
                transportationSectionOpen && styles['is-active']
              )}
              onClick={() => setTransportationSectionOpen(!transportationSectionOpen)}
            >
              <p className={styles['option__list__item__ttl__txt']}>{t('Transportation')}</p>
              <p className={styles['option__list__item__ttl__ic']}>
                <span className={baseStyles['color-sub--bg']}></span>
                <span className={baseStyles['color-sub--bg']}></span>
              </p>
            </div>
            <ul
              className={clsx(
                styles['option__list__item__content'],
                transportationSectionOpen && styles['is-active']
              )}
            >
              {product.transportations.map((transportation, idx) => (
                <ProductServiceListItem key={idx} service={transportation} />
              ))}
            </ul>
          </div>
        )}
        {hasAddOns && (
          <div className={styles['option__list__item']}>
            <div
              className={clsx(
                styles['option__list__item__ttl'],
                addOnsSectionOpen && styles['is-active']
              )}
              onClick={() => setAddOnsSectionOpen(!addOnsSectionOpen)}
            >
              <p className={styles['option__list__item__ttl__txt']}>{t('Add-ons')}</p>
              <p className={styles['option__list__item__ttl__ic']}>
                <span className={baseStyles['color-sub--bg']}></span>
                <span className={baseStyles['color-sub--bg']}></span>
              </p>
            </div>
            <ul
              className={clsx(
                styles['option__list__item__content'],
                addOnsSectionOpen && styles['is-active']
              )}
            >
              {product.addOns.map((addOn, idx) => {
                if (config.enableHideTooManyServices) {
                  if (!showAll && idx === threshold) {
                    return (
                      <li key={idx} className="c-schedule2__list">
                        <div className={styles['option__list__item__content__left']}>
                          <a
                            className={clsx(
                              styles['option__list__item__content__ttl'],
                              styles['show_all_options']
                            )}
                            onClick={() => setShowAll(true)}
                          >
                            {t('Show All Add-ons')}
                          </a>
                        </div>
                      </li>
                    );
                  }

                  if (!showAll && idx >= threshold) {
                    return null;
                  }
                }
                return <ProductServiceListItem key={idx} service={addOn} />;
              })}
            </ul>
          </div>
        )}
      </div>
    </ContentSection>
  );
};
